import { ReactiveController, ReactiveControllerHost } from 'lit';
import { authService } from '../services/auth-service';

/**
 * Lit Controller to trigger requestUpdate if status of the auth-service changes.
 */
export class AuthStateController implements ReactiveController {
  private host: ReactiveControllerHost;

  constructor(
    host: ReactiveControllerHost,
  ) {
    this.host = host;
    this.host.addController(this);
  }

  authStateChanged = () => {
    this.host.requestUpdate();
  }

  hostConnected() {
    authService.addEventListener('authStateChanged', this.authStateChanged);
  }

  hostDisconnected() {
    authService.removeEventListener('authStateChanged', this.authStateChanged);
  }
}
